export const MarketoConfig = {
  MUNCHKIN_ID: '424-IAB-218',
  PARTITION: 'j1RQ',
  SRC_URL: 'https://munchkin.marketo.net/munchkin.js',
  SUBMIT_ENDPOINT: '/api/v1/xms2/marketo/submit_form',
  GET_FORM_ENDPOINT: '/api/v1/xms2/marketo/get_form',
  DEVELOPMENT_BASE_URL: 'http://localhost:8080',
  STAGING_BASE_URL: 'https://api.squareupstaging.com',
  PRODUCTION_BASE_URL: 'https://api.squareup.com',
};
